import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { firebaseDB } from '../../../firebase-config';
import { Alert, Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAuth } from '../../../contexts';
import '../user.scss';
import { AGE_ARRAY } from '../../../consts/ages';

export const AddChild = ({ getUserChildren }) => {
    const [nameChild, setNameChild] = useState('');
    const [ageChild, setAgeChild] = useState('');
    const [errorValue, setErrorValue] = useState(false);

    const { user } = useAuth();
    const usersChildrenCollectionRef = collection(firebaseDB, `usersChildren/${user.uid}/children`);
    const handleName = (name) => setNameChild(name);
    const handleSelect = (select) => setAgeChild(select);
    const handleSubmit = async (element) => {
        element.preventDefault();
        setErrorValue(false);
        if (!nameChild.trim() || !ageChild) {
            setErrorValue(true);
            return;
        }
        try {
            setNameChild('');
            setAgeChild('');
            await addDoc(usersChildrenCollectionRef, {
                name: nameChild,
                age: ageChild
            });
            getUserChildren();
        } catch (error) {
            console.log(error.message);
        };
    };

    return (
        <div>
            <h3>Додати дитину</h3>
            <form className='user-add_form' onSubmit={handleSubmit} autoComplete='off'>
                {errorValue &&
                    <Alert severity='error' sx={{ marginBottom: '16px' }}>
                        Поля не можуть бути пустими
                    </Alert>
                }
                <TextField
                    type='text'
                    label="Ім'я дитини"
                    placeholder="Введіть ім'я дитини"
                    value={nameChild}
                    onChange={e => handleName(e.target.value)}
                    sx={{ marginBottom: '20px' }} />
                <FormControl>
                    <InputLabel id='demo-simple-select-error-label'>
                        Виберіть вік дитини
                    </InputLabel>
                    <Select
                        sx={{ marginBottom: '10px' }}
                        labelId='demo-simple-select-error-label'
                        id='demo-simple-select-error'
                        value={ageChild}
                        label='Виберіть вік дитини'
                        onChange={e => handleSelect(e.target.value)}
                        renderValue={(value) => `${value}`}>
                        {AGE_ARRAY.map((text, index) =>
                            <MenuItem value={text} key={index}>
                                {text}
                            </MenuItem>)}
                    </Select>
                </FormControl>
                <Button type='submit'
                    variant='contained'
                    sx={{
                        backgroundColor: '#6565f5',
                        '&:hover': { backgroundColor: '#4d4de9' }
                    }}>
                    Зберегти
                </Button>
            </form>
        </div>
    )
}